/** Word-level IPA overrides for Spanish. */
export const es: Record<string, string> = {
  arts: '/aʁ/', // French "Arts" in Cortázar (Pont des Arts)
  aureliano: '/awɾeˈljano/',
  beatriz: '/beaˈtɾis/',
  buendía: '/bwenˈdia/',
  cañabrava: '/kaɲaˈβɾaβa/',
  conti: '/ˈkonti/', // Italian name in Cortázar
  fierro: '/ˈfjeɾo/',
  macondo: '/maˈkondo/',
  pont: '/pɔ̃/', // French in Cortázar
  porfirio: '/poɾˈfiɾjo/',
  quai: '/ke/', // French in Cortázar
  quedóse: '/keˈðose/',
  rue: '/ʁy/', // French in Cortázar
  seine: '/sɛn/', // French river in Cortázar
  sépase: '/ˈsepase/',
  urbino: '/uɾˈβino/',
  vacilante: '/basiˈlante/',
  viterbo: '/biˈteɾβo/',
};
